import { MenuItem } from "@mui/material"
import { observer } from "mobx-react-lite"
import Value from "pages/content/store/value"
import { InputLabel, InputWrapper, SelectComponent } from "../input/styled"
import Tooltip from "../tooltip"

type Props = {
  label?: string,
  options: string[],
  tooltip?: string,
  value: Value
}

const ContentSelect = observer(({ label, value, options, tooltip }: Props) => {

  return (
    <InputWrapper>
      <InputLabel>
        { label }
        <Tooltip title={tooltip} />
      </InputLabel>
      <SelectComponent 
        value={value.value} 
        onChange={e => value.set(e.target.value as string)}
      >
        { options.map((str, index) => (
          <MenuItem value={str} key={index}>{ str }</MenuItem>
        ))}
      </SelectComponent>
    </InputWrapper>
  )
})

export default ContentSelect